module.exports = __webpack_public_path__ + "img/李论.8d4414e6.jpg";